import React from 'react';
import { RenderButton } from '~button';
import Container from './Container';
import ContainerActions from './ContainerActions';
import Action from './Action';
import modalPropTypes from '../../../prop-types/modalPropTypes';

var ModalFooter = function ModalFooter(_ref) {
  var footerPre = _ref.footerPre,
      footerPost = _ref.footerPost,
      footerActions = _ref.footerActions,
      handleOnDismiss = _ref.handleOnDismiss;
  return /*#__PURE__*/React.createElement(Container, null, footerPre && footerPre, footerActions && /*#__PURE__*/React.createElement(ContainerActions, null, footerActions.map(function (item, index) {
    var onClick = item.onClick,
        isExternal = item.isExternal,
        path = item.path,
        label = item.label,
        skin = item.skin,
        icon = item.icon,
        btnType = item.btnType,
        size = item.size;
    return /*#__PURE__*/React.createElement(Action, {
      key: index
    }, /*#__PURE__*/React.createElement(RenderButton, {
      onClick: onClick,
      isExternal: isExternal,
      path: path,
      skin: skin,
      icon: icon,
      btnType: btnType,
      size: size,
      label: label,
      onClickLinkCallback: function onClickLinkCallback() {
        return setTimeout(function () {
          handleOnDismiss();
        }, 100);
      }
    }));
  })), footerPost && footerPost);
};

ModalFooter.defaultProps = {
  footerActions: null,
  footerPre: null,
  footerPost: null
};
export default ModalFooter;